
  import {defineComponent,PropType,inject,Ref,ref,watchEffect} from "vue"
  import MessageComponent from "@/components/Message.component.vue";
  import {Message} from "@/models/message.interface";
  import {Device} from "@/models/devices.interface";
  import {SMSMessage} from "@/models/message.interface";

  export default defineComponent({
   name: "ListMessageComponent",
   components:{
    MessageComponent
   },
   props:{
     devices:{
       type:Array as PropType<SMSMessage[]>
     }     ,
     title:{
	type: String as PropType<string>
     }
    },
    setup(props,context){

      let pagina=inject("pagina") as Ref<number>;

    
      
      const loadMore = ()=>{
	 
	 pagina.value++;
	 context.emit("moreMessages","");
      }

      const loadLess = ()=>{
	pagina.value--;
	context.emit("lessMessages","");
      }

      const reorder = (objetoModified)=>{
	
	
      };
      return {reorder,loadMore,loadLess}
    }
  });
